/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  LocationConfigDTO
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Get location configuration by name
 */
export const getLocationConfig = (
    configName: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationConfigDTO>(
      {url: `/api/v1/location-config/${configName}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetLocationConfigInfiniteQueryKey = (configName?: string,) => {
    return [
    'infinite', `/api/v1/location-config/${configName}`
    ] as const;
    }

export const getGetLocationConfigQueryKey = (configName?: string,) => {
    return [
    `/api/v1/location-config/${configName}`
    ] as const;
    }

    
export const getGetLocationConfigInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLocationConfig>>>, TError = unknown>(configName: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationConfigInfiniteQueryKey(configName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationConfig>>> = ({ signal }) => getLocationConfig(configName, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(configName), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLocationConfigInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationConfig>>>
export type GetLocationConfigInfiniteQueryError = unknown


export function useGetLocationConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationConfig>>>, TError = unknown>(
 configName: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationConfig>>,
          TError,
          Awaited<ReturnType<typeof getLocationConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationConfig>>>, TError = unknown>(
 configName: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationConfig>>,
          TError,
          Awaited<ReturnType<typeof getLocationConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationConfig>>>, TError = unknown>(
 configName: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get location configuration by name
 */

export function useGetLocationConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationConfig>>>, TError = unknown>(
 configName: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLocationConfigInfiniteQueryOptions(configName,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetLocationConfigQueryOptions = <TData = Awaited<ReturnType<typeof getLocationConfig>>, TError = unknown>(configName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationConfigQueryKey(configName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationConfig>>> = ({ signal }) => getLocationConfig(configName, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(configName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocationConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLocationConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationConfig>>>
export type GetLocationConfigQueryError = unknown


export function useGetLocationConfig<TData = Awaited<ReturnType<typeof getLocationConfig>>, TError = unknown>(
 configName: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationConfig>>,
          TError,
          Awaited<ReturnType<typeof getLocationConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationConfig<TData = Awaited<ReturnType<typeof getLocationConfig>>, TError = unknown>(
 configName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationConfig>>,
          TError,
          Awaited<ReturnType<typeof getLocationConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationConfig<TData = Awaited<ReturnType<typeof getLocationConfig>>, TError = unknown>(
 configName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get location configuration by name
 */

export function useGetLocationConfig<TData = Awaited<ReturnType<typeof getLocationConfig>>, TError = unknown>(
 configName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLocationConfigQueryOptions(configName,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update existing location configuration
 */
export const updateLocationConfig = (
    configName: string,
    locationConfigDTO: LocationConfigDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<LocationConfigDTO>(
      {url: `/api/v1/location-config/${configName}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: locationConfigDTO
    },
      options);
    }
  


export const getUpdateLocationConfigMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLocationConfig>>, TError,{configName: string;data: LocationConfigDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLocationConfig>>, TError,{configName: string;data: LocationConfigDTO}, TContext> => {

const mutationKey = ['updateLocationConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLocationConfig>>, {configName: string;data: LocationConfigDTO}> = (props) => {
          const {configName,data} = props ?? {};

          return  updateLocationConfig(configName,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateLocationConfigMutationResult = NonNullable<Awaited<ReturnType<typeof updateLocationConfig>>>
    export type UpdateLocationConfigMutationBody = LocationConfigDTO
    export type UpdateLocationConfigMutationError = unknown

    /**
 * @summary Update existing location configuration
 */
export const useUpdateLocationConfig = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLocationConfig>>, TError,{configName: string;data: LocationConfigDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLocationConfig>>,
        TError,
        {configName: string;data: LocationConfigDTO},
        TContext
      > => {

      const mutationOptions = getUpdateLocationConfigMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get all location configurations
 */
export const getAllLocationConfigs = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationConfigDTO[]>(
      {url: `/api/v1/location-config`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAllLocationConfigsInfiniteQueryKey = () => {
    return [
    'infinite', `/api/v1/location-config`
    ] as const;
    }

export const getGetAllLocationConfigsQueryKey = () => {
    return [
    `/api/v1/location-config`
    ] as const;
    }

    
export const getGetAllLocationConfigsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllLocationConfigs>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllLocationConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllLocationConfigsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllLocationConfigs>>> = ({ signal }) => getAllLocationConfigs(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllLocationConfigs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllLocationConfigsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllLocationConfigs>>>
export type GetAllLocationConfigsInfiniteQueryError = unknown


export function useGetAllLocationConfigsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllLocationConfigs>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllLocationConfigs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllLocationConfigs>>,
          TError,
          Awaited<ReturnType<typeof getAllLocationConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllLocationConfigsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllLocationConfigs>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllLocationConfigs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllLocationConfigs>>,
          TError,
          Awaited<ReturnType<typeof getAllLocationConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllLocationConfigsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllLocationConfigs>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllLocationConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all location configurations
 */

export function useGetAllLocationConfigsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllLocationConfigs>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllLocationConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllLocationConfigsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllLocationConfigsQueryOptions = <TData = Awaited<ReturnType<typeof getAllLocationConfigs>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllLocationConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllLocationConfigsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllLocationConfigs>>> = ({ signal }) => getAllLocationConfigs(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllLocationConfigs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllLocationConfigsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllLocationConfigs>>>
export type GetAllLocationConfigsQueryError = unknown


export function useGetAllLocationConfigs<TData = Awaited<ReturnType<typeof getAllLocationConfigs>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllLocationConfigs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllLocationConfigs>>,
          TError,
          Awaited<ReturnType<typeof getAllLocationConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllLocationConfigs<TData = Awaited<ReturnType<typeof getAllLocationConfigs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllLocationConfigs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllLocationConfigs>>,
          TError,
          Awaited<ReturnType<typeof getAllLocationConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllLocationConfigs<TData = Awaited<ReturnType<typeof getAllLocationConfigs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllLocationConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all location configurations
 */

export function useGetAllLocationConfigs<TData = Awaited<ReturnType<typeof getAllLocationConfigs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllLocationConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllLocationConfigsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create new location configuration
 */
export const createLocationConfig = (
    locationConfigDTO: LocationConfigDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationConfigDTO>(
      {url: `/api/v1/location-config`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: locationConfigDTO, signal
    },
      options);
    }
  


export const getCreateLocationConfigMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLocationConfig>>, TError,{data: LocationConfigDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createLocationConfig>>, TError,{data: LocationConfigDTO}, TContext> => {

const mutationKey = ['createLocationConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLocationConfig>>, {data: LocationConfigDTO}> = (props) => {
          const {data} = props ?? {};

          return  createLocationConfig(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateLocationConfigMutationResult = NonNullable<Awaited<ReturnType<typeof createLocationConfig>>>
    export type CreateLocationConfigMutationBody = LocationConfigDTO
    export type CreateLocationConfigMutationError = unknown

    /**
 * @summary Create new location configuration
 */
export const useCreateLocationConfig = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLocationConfig>>, TError,{data: LocationConfigDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLocationConfig>>,
        TError,
        {data: LocationConfigDTO},
        TContext
      > => {

      const mutationOptions = getCreateLocationConfigMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get all configurations for an entity type
 */
export const getLocationConfigsByEntityType = (
    entityType: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationConfigDTO[]>(
      {url: `/api/v1/location-config/entity/${entityType}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetLocationConfigsByEntityTypeInfiniteQueryKey = (entityType?: string,) => {
    return [
    'infinite', `/api/v1/location-config/entity/${entityType}`
    ] as const;
    }

export const getGetLocationConfigsByEntityTypeQueryKey = (entityType?: string,) => {
    return [
    `/api/v1/location-config/entity/${entityType}`
    ] as const;
    }

    
export const getGetLocationConfigsByEntityTypeInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLocationConfigsByEntityType>>>, TError = unknown>(entityType: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationConfigsByEntityType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationConfigsByEntityTypeInfiniteQueryKey(entityType);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationConfigsByEntityType>>> = ({ signal }) => getLocationConfigsByEntityType(entityType, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(entityType), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationConfigsByEntityType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLocationConfigsByEntityTypeInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationConfigsByEntityType>>>
export type GetLocationConfigsByEntityTypeInfiniteQueryError = unknown


export function useGetLocationConfigsByEntityTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationConfigsByEntityType>>>, TError = unknown>(
 entityType: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationConfigsByEntityType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationConfigsByEntityType>>,
          TError,
          Awaited<ReturnType<typeof getLocationConfigsByEntityType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationConfigsByEntityTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationConfigsByEntityType>>>, TError = unknown>(
 entityType: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationConfigsByEntityType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationConfigsByEntityType>>,
          TError,
          Awaited<ReturnType<typeof getLocationConfigsByEntityType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationConfigsByEntityTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationConfigsByEntityType>>>, TError = unknown>(
 entityType: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationConfigsByEntityType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all configurations for an entity type
 */

export function useGetLocationConfigsByEntityTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationConfigsByEntityType>>>, TError = unknown>(
 entityType: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationConfigsByEntityType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLocationConfigsByEntityTypeInfiniteQueryOptions(entityType,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetLocationConfigsByEntityTypeQueryOptions = <TData = Awaited<ReturnType<typeof getLocationConfigsByEntityType>>, TError = unknown>(entityType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationConfigsByEntityType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationConfigsByEntityTypeQueryKey(entityType);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationConfigsByEntityType>>> = ({ signal }) => getLocationConfigsByEntityType(entityType, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(entityType), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocationConfigsByEntityType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLocationConfigsByEntityTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationConfigsByEntityType>>>
export type GetLocationConfigsByEntityTypeQueryError = unknown


export function useGetLocationConfigsByEntityType<TData = Awaited<ReturnType<typeof getLocationConfigsByEntityType>>, TError = unknown>(
 entityType: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationConfigsByEntityType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationConfigsByEntityType>>,
          TError,
          Awaited<ReturnType<typeof getLocationConfigsByEntityType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationConfigsByEntityType<TData = Awaited<ReturnType<typeof getLocationConfigsByEntityType>>, TError = unknown>(
 entityType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationConfigsByEntityType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationConfigsByEntityType>>,
          TError,
          Awaited<ReturnType<typeof getLocationConfigsByEntityType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationConfigsByEntityType<TData = Awaited<ReturnType<typeof getLocationConfigsByEntityType>>, TError = unknown>(
 entityType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationConfigsByEntityType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all configurations for an entity type
 */

export function useGetLocationConfigsByEntityType<TData = Awaited<ReturnType<typeof getLocationConfigsByEntityType>>, TError = unknown>(
 entityType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationConfigsByEntityType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLocationConfigsByEntityTypeQueryOptions(entityType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get all location configurations including inactive ones
 */
export const getAllLocationConfigsIncludingInactive = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationConfigDTO[]>(
      {url: `/api/v1/location-config/all`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAllLocationConfigsIncludingInactiveInfiniteQueryKey = () => {
    return [
    'infinite', `/api/v1/location-config/all`
    ] as const;
    }

export const getGetAllLocationConfigsIncludingInactiveQueryKey = () => {
    return [
    `/api/v1/location-config/all`
    ] as const;
    }

    
export const getGetAllLocationConfigsIncludingInactiveInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllLocationConfigsIncludingInactiveInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>> = ({ signal }) => getAllLocationConfigsIncludingInactive(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllLocationConfigsIncludingInactiveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>>
export type GetAllLocationConfigsIncludingInactiveInfiniteQueryError = unknown


export function useGetAllLocationConfigsIncludingInactiveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>,
          TError,
          Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllLocationConfigsIncludingInactiveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>,
          TError,
          Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllLocationConfigsIncludingInactiveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all location configurations including inactive ones
 */

export function useGetAllLocationConfigsIncludingInactiveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllLocationConfigsIncludingInactiveInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllLocationConfigsIncludingInactiveQueryOptions = <TData = Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllLocationConfigsIncludingInactiveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>> = ({ signal }) => getAllLocationConfigsIncludingInactive(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllLocationConfigsIncludingInactiveQueryResult = NonNullable<Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>>
export type GetAllLocationConfigsIncludingInactiveQueryError = unknown


export function useGetAllLocationConfigsIncludingInactive<TData = Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>,
          TError,
          Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllLocationConfigsIncludingInactive<TData = Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>,
          TError,
          Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllLocationConfigsIncludingInactive<TData = Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all location configurations including inactive ones
 */

export function useGetAllLocationConfigsIncludingInactive<TData = Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllLocationConfigsIncludingInactive>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllLocationConfigsIncludingInactiveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




